// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import { injectIntl } from 'react-intl';

// Components
import StartPage from './StartPage';

// Actions
import { setShowQuoteApptError } from 'store/reducers/quoteAppt/actions';

// Selector
import { getCTABanner } from 'store/reducers/optimizelyABTest/selectors';
import { getShowQuoteApptError } from 'store/reducers/quoteAppt/selectors';

const mapStateToProps = (state: State) => ({
  CTABanner: getCTABanner(state),
  showQuoteApptError: getShowQuoteApptError(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    { setShowQuoteApptError }
  )
)(StartPage);



// WEBPACK FOOTER //
// ./src/components/pages/StartPage/StartPageContainer.js